import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { handleAuthError as handleAuthErrorFn } from '../utils/auth/auth-errors';

export function useAuthErrorHandler() {
  const { t } = useTranslation();

  const handleAuthError = useCallback(
    (error: unknown, options?: { showToast?: boolean }) => {
      return handleAuthErrorFn(error, t, options ?? {});
    },
    [t],
  );

  return handleAuthError;
}
